<template>
    <div class="SocietyContactContainer shadow" v-on:click="onClick">
        <div class="SocietyContactContainer-img">
            <div
                    v-bind:class="age >= 18 ? 'senior' : 'junior'"
                    class="SocietyContactContainer-img-wrapper"></div>
            <i class="fi"
               v-bind:class="age >= 18 ? 'flaticon-employee' : 'flaticon-baby'"></i>
        </div>
        <div class="SocietyContactContainer-info text-truncate">
            <div class="text-uppercase">{{contact.surname}}</div>
            <div class="text-uppercase">{{contact.name}}</div>
            <div class="mt-2 small">{{contact.email}}</div>
            <div class="small">Nato il {{contact.birth_date | date}}</div>
        </div>
        <div class="SocietyContactContainer-profile" v-bind:class="age >= 18 ? 'senior' : 'junior'">
            <div class="SocietyContactContainer-profile-label">{{age >= 18 ? 'senior' : 'junior'}}</div>
        </div>
        <inter-modal
                title-icon="flaticon-info"
                :buttonPrimary="buttons.primary"
                :buttonSecondary="buttons.secondary"
                :title="confirmTitle"
                :visible="showModal"
                size="sm"
                @onPrimaryClick="() => { showModal = false; $emit('onClick', contact)}"
                @onSecondaryClick="() => { showModal = false }">
            <div class="mx-3">{{confirmText}}</div>
        </inter-modal>
    </div>
</template>

<script>

    import Contact from '@/models/Contact';
    import Moment from 'moment';
    import InterModal from "../../../../components/modal/InterModal";

    export default {
        name: "SocietyContactContainer",
        components: {InterModal},
        data() {
            return {
                buttons: {
                    primary: {
                        label: 'Procedi',
                    },
                    secondary: {
                        label: 'Annulla',
                    }
                },
                showModal: false
            }
        },
        props: {
            contact: {
                type: Object,
                default: () => Object.assign({}, Contact)
            },
            confirmTitle: {
                type: String,
                default: 'Conferma azione'
            },
            confirmText: {
                type: String,
                default: 'Sei proprio sicuro ?'
            },
            confirmAction: {
                type: Boolean,
                default: true
            }
        },
        mounted() {
            this.$root.$on('bv::modal::hide', () => {
                this.showModal = false;
            })
        },
        computed: {
            age: function() {
                if(this.contact.birth_date) {
                    return Moment().diff(this.contact.birth_date, 'years');
                } else {
                    return 0;
                }
            }
        },
        methods :{
            onClick : function() {
                if(this.confirmAction) {
                    this.showModal = true;
                } else {
                    this.$emit('onClick', this.contact)
                }
            }
        }
    }
</script>

<style scoped>

</style>